import classNames from 'classnames'
import { useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { updateClassDetailById } from '@/store/knowledge/actions'
import { HelperService } from '@/services/helper.service'
import LinkCourseToAgent, { lmsListData } from './LinkCourseModal'

const helperService = new HelperService()

interface ClassSettingsProps {
  classDetail: any
  courseLMS: any
  onUpdate: () => void
  onLMSUpdate: () => void
  onUnlinkLMS: () => void
}

const ClassSettings = ({
  classDetail,
  courseLMS,
  onUpdate,
  onLMSUpdate,
  onUnlinkLMS,
}: ClassSettingsProps) => {
  const { t } = useTranslation('translation')
  const dispatch = useDispatch()
  const [localClassDetail, setLocalClassDetail] = useState(classDetail)
  const [showCreateClassModal, setShowCreateClassModal] = useState(false)

  const showCreateClassModalHandler = () => {
    setShowCreateClassModal(!showCreateClassModal)
  }

  const funUpdateClassDetailById = async () => {
    try {
      await dispatch(
        updateClassDetailById(classDetail._id, {
          name: localClassDetail?.name,
        }),
      )
      onUpdate()
      helperService.showToaster(
        t('Class name updated successfully.'),
        'success',
      )
    } catch (error: any) {
      helperService.showToaster(t('Failed to update class name.'), 'error')
    }
  }

  return (
    <>
      <LinkCourseToAgent
        show={showCreateClassModal}
        onHide={showCreateClassModalHandler}
        confirmHandler={() => {
          showCreateClassModalHandler()
          onLMSUpdate()
        }}
        onLMSUpdate={onLMSUpdate}
        id={classDetail ? classDetail._id : null}
        courseLMS={courseLMS}
      />
      <Row>
        <Col md={12}>
          <div className="form-group mb-24">
            <label className="font-600 font-16">{t('Class Name')}</label>
            <div className="d-flex">
              <input
                className="form-control h-auto radius-8"
                placeholder={t('Name of Class')}
                defaultValue={localClassDetail?.name || ''}
                onChange={(e: any) => {
                  setLocalClassDetail({
                    ...localClassDetail,
                    name: e.target.value,
                  })
                }}
              />

              <button
                disabled={!localClassDetail || !localClassDetail.name}
                className={classNames({
                  'btn font-sm ml-3 text-nowrap': true,
                  'bg-grey-head border clr-grey-txt':
                    !localClassDetail || !localClassDetail.name,
                  'btn-primary': localClassDetail && localClassDetail.name,
                })}
                onClick={funUpdateClassDetailById}
              >
                {t('Save Changes')}
              </button>
            </div>
          </div>

          <div className="form-group">
            <label className="font-600 font-16">
              {t('LMS Course Mapping')}
              {!courseLMS && (
                <button
                  className="btn btn-link ml-auto py-1"
                  onClick={showCreateClassModalHandler}
                >
                  {t('+ Add')}
                </button>
              )}
            </label>
            <div className="table-responsive manage-table">
              <table className="table font-16 font-600">
                <thead>
                  <tr>
                    <th className="border-0 font-600 pl-lg-4 py-2">
                      {t('LMS')}
                    </th>
                    <th className="border-0 font-600 pl-lg-4 py-2">
                      {courseLMS?.provider === 'canvas' &&
                      courseLMS?.lms_course?.name
                        ? t('Course Name')
                        : t('Course ID')}
                    </th>
                    <th className="border-0 font-600 pl-lg-4 py-2">
                      {t('Action')}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="pl-lg-4">
                      {courseLMS &&
                        lmsListData.find(
                          (e: any) => e.value === courseLMS?.provider,
                        )?.label}
                    </td>
                    <td className="pl-lg-4">
                      {courseLMS?.provider === 'canvas' &&
                      courseLMS?.lms_course?.name
                        ? courseLMS?.lms_course?.name
                        : courseLMS?.course_id}
                    </td>
                    <td className="pl-lg-4">
                      {courseLMS && (
                        <>
                          <button
                            className="btn btn-outline-primary border-0 font-600 p-0 mr-3"
                            onClick={showCreateClassModalHandler}
                          >
                            {t('Edit')}
                          </button>
                          <button
                            className="btn btn-outline-danger border-0 font-600 p-0"
                            onClick={onUnlinkLMS}
                          >
                            {t('Delete')}
                          </button>
                        </>
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </Col>
      </Row>
    </>
  )
}

export default ClassSettings
